/** Source revision: Glov-ai/gengage-assistant-fe 4a1cfe9. */
export const CHATFE_VERSION = '0.7.25';
